import { render, staticRenderFns } from "./GerenciamentoTransporteForm.vue?vue&type=template&id=3a222418"
import script from "./GerenciamentoTransporteForm.vue?vue&type=script&lang=js"
export * from "./GerenciamentoTransporteForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports